import { FormattedMessage } from "@eroad/i18n/FormattedMessage";
import { MehOutlined } from "@eroad/icons/antd";

import { UILibraryIntlProvider } from "../../../providers/UILibraryIntlProvider";
import { useStyles } from "./PageError.styles";
import type { PageErrorProps } from "./types";

/**
 * This is a custom MyEROAD component. This reports an error state when a page fails to load.
 */
const PageError = ({ message }: PageErrorProps) => {
  const classes = useStyles();

  return (
    <UILibraryIntlProvider>
      <div className={classes.root}>
        <MehOutlined className={classes.icon} />
        {message ?? <FormattedMessage id="ui.library.page.error" />}
      </div>
    </UILibraryIntlProvider>
  );
};

export { PageError };
